import { render, staticRenderFns } from "./WizardUrlIcon.vue?vue&type=template&id=0c50c980&"
import script from "./WizardUrlIcon.vue?vue&type=script&lang=js&"
export * from "./WizardUrlIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports